import React from 'react';

import { WorkInProgressPage } from '../../../features/WorkInProgressPage/WorkInProgressPage';

export const Rrc: React.VFC = () => {
    return <WorkInProgressPage project='RRC' />;
};
